export function notify(type, message){
    window.dispatchEvent(new CustomEvent('toast::show', {
        detail: {
            type: type,
            message: message
        }
    }))
}
